import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { SnapshotId } from '@ipfabric/utils';
import {
  type DeviceViewElementType,
  type DeviceViewEntityId,
  isEdgeEntity,
  isNodeEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';
import { loadDeviceViewDeviceSettings } from './loadDeviceViewDeviceSettings';
import { loadDeviceViewEdgeSettings } from './loadDeviceViewEdgeSettings';

const hasValidData = (snapshotId: string | null): snapshotId is string =>
  snapshotId !== null;

export interface LoadDeviceViewDataCommand {
  deviceViewElement: DeviceViewElementType;
  deviceViewEntityId: DeviceViewEntityId;
  onDataLoadingChange?: (value: boolean) => void;
  snapshotId: SnapshotId | null;
}

export const loadDeviceViewData: DeviceViewCommandFactory<
  LoadDeviceViewDataCommand
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TBD eventually cleanup
> = (cmdContext, dispatch) => async (command) => {
  const deviceViewEntity = cmdContext
    .getState()
    .deviceViewEntities.find(
      (entity) =>
        entity.id === command.deviceViewEntityId &&
        entity.deviceViewElement === command.deviceViewElement,
    );
  if (deviceViewEntity === undefined) {
    return;
  }
  if (deviceViewEntity.deviceViewElement === 'labels') {
    return;
  }
  if (hasValidData(command.snapshotId)) {
    command.onDataLoadingChange?.(true);
    try {
      if (isEdgeEntity(deviceViewEntity)) {
        if (deviceViewEntity.loaded) {
          return;
        }
        await dispatch(loadDeviceViewEdgeSettings, { deviceViewEntity });
      } else if (isNodeEntity(deviceViewEntity)) {
        await dispatch(loadDeviceViewDeviceSettings, {
          deviceViewEntityId: deviceViewEntity.id,
          snapshotId: command.snapshotId,
          isPathLookupNode: deviceViewEntity.isPathLookupNode,
        });
      } else if (
        deviceViewEntity.deviceViewElement !== 'packetDetails' &&
        deviceViewEntity.deviceViewElement !== 'pathlookupDebug'
      ) {
        stumble('unknown device view entity type');
      }
    } finally {
      command.onDataLoadingChange?.(false);
    }
  }
};
